import { Tooltip } from '@mui/material'
import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'

const AgreeIcon = ({ ico, value, disagreeText, text }) => {

    const [className, setClassName] = useState('')

    useEffect(() => {
        setClass()
    }, [value])

    const setClass = () => {
        if (value === true) {
            setClassName('supplyAgrees__agree')
        } else if (value === false) {
            setClassName('supplyAgrees__disagree')
        } else {
            setClassName('supplyAgrees__approval')
        }
    }

  return (
    <div className={className}>
        <Tooltip title={text + (disagreeText ? `: ${disagreeText}` : '')}>
            {ico}
        </Tooltip>
    </div>
  )
}

export default AgreeIcon